function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { connect } from 'react-redux';
import buildObjectListCached from "./buildObjectListCached";
var getDisplayName = function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
};

// NOTE: this is duplicated in ab-common
var getApiObjectList = function getApiObjectList(object_type, prop_name_parameter, filter // eslint-disable-line @typescript-eslint/no-explicit-any
) {
  return function (Component) {
    if (typeof object_type !== 'string') {
      throw new TypeError('getApiObjectList: first parameter must be a string');
    }
    if (object_type.length <= 0) {
      throw new Error('getApiObjectList: first parameter must be a non-empty string');
    }
    var cachedBuilder = buildObjectListCached(object_type);
    var propName = prop_name_parameter || object_type;
    var mapStateToProps = function mapStateToProps(state, own_props) {
      var raw_data = state && state.api ? cachedBuilder(state) : [];
      var data = filter ? filter(raw_data, own_props) : raw_data;
      return _defineProperty({}, propName, data);
    };
    var Wrapper = connect(mapStateToProps)(Component);
    Wrapper.displayName = "getApiObjectList(".concat(getDisplayName(Component), ",").concat(object_type, ")");
    return Wrapper;
  };
};
export default getApiObjectList;